import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemsListRowItemBaseLink } from '../list-row-item-base-link';
import { GetPropertyByString } from '@fi-shared/fi-shared-services/extensions.service';

@Component({
    selector: 'fi-items-list-row-item-array-a',
    templateUrl: './array-a.component.html',
    styleUrls: ['./array-a.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ItemsListRowItemArrayAComponent extends ItemsListRowItemBaseLink {
    // note: the same as ItemsListRowItemArraySpanComponent
    GetToolTip() {
        const result = [],
            items = this.data[this.head.PropertyName];
        for (let i = 0; i < items.length; i++) {
            result.push(GetPropertyByString(items[i], this.head.ChildPropertyName));
        }

        return result.join(', ');
    }

    onClick($event: MouseEvent, item) {
        $event.preventDefault();
        const state = this.GetUiSref();
        const params = this.GetUiSrefParams(item);
        this.stateService.go(state, params, { reload: true });
        if (this.head.Properties?.ExtraProperties?.onClick)
            this.head.Properties.ExtraProperties.onClick($event, item, undefined);
    }
}
